import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEncrypted = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_818_27345",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_818_27345)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.725 14.9996H13.275L12.65 11.3746C12.9833 11.2246 13.25 11.0038 13.45 10.7121C13.65 10.4204 13.75 10.0996 13.75 9.74961C13.75 9.26628 13.5792 8.85378 13.2375 8.51211C12.8958 8.17044 12.4833 7.99961 12 7.99961C11.5167 7.99961 11.1042 8.17044 10.7625 8.51211C10.4208 8.85378 10.25 9.26628 10.25 9.74961C10.25 10.0996 10.35 10.4204 10.55 10.7121C10.75 11.0038 11.0167 11.2246 11.35 11.3746L10.725 14.9996ZM12 21.9746C9.66667 21.3913 7.75 20.0371 6.25 17.9121C4.75 15.7871 4 13.4579 4 10.9246V4.97461L12 1.97461L20 4.97461V10.9246C20 13.4579 19.25 15.7871 17.75 17.9121C16.25 20.0371 14.3333 21.3913 12 21.9746ZM12 20.4246C13.9167 19.7913 15.4792 18.5954 16.6875 16.8371C17.8958 15.0788 18.5 13.1079 18.5 10.9246V6.02461L12 3.57461L5.5 6.02461V10.9246C5.5 13.1079 6.10417 15.0788 7.3125 16.8371C8.52083 18.5954 10.0833 19.7913 12 20.4246Z",
			fill: "currentColor"
		})
	})]
});
export default SvgEncrypted;
